export function commonFunc() {
	// handleSamePageAnchorLinks();
	// handleCrossPagesAnchorLinks();
  anchorLinks();
}

function anchorLinks() {
  let urlHash = location.hash;
  
  // 1. 別ページからハッシュ付きで遷移してきた場合
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      let headerHeight = $('.l-header').length ? $('.l-header').outerHeight() : 0;
      let target = $(urlHash);
      if (target.length) {
        let position = target.offset().top - headerHeight;
        $('body,html').scrollTop(position);
      }
    }, 100);
  }

  // 2. リンククリック時の挙動
  $('a[href*="#"]').click(function() {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      
      let href = $(this).attr("href");
      let hash = href.substr(href.indexOf('#'));
      let target = $(hash === "#" || hash === "" ? 'html' : hash);
      
      if (target.length) {
        let headerHeight = $('.l-header').length ? $('.l-header').outerHeight() : 0;
        let position = target.offset().top - headerHeight;
        
        $('body,html').scrollTop(position);
        
        if(hash !== "#" && hash !== "") {
            history.pushState(null, null, hash);
        }
        return false;
      }
    }
  });
}

/**
 * アンカーリンク（同一ページ内）
 */
// function handleSamePageAnchorLinks() {
// 	const header = document.querySelector('.l-header');
// 	const headerHeight = header ? header.offsetHeight : 0;

// 	function handleAnchorClick(event) {
// 		const target = event.target.closest('a[href*="#"]');
// 		if (target) {
// 			const href = target.getAttribute('href');
// 			const anchorIndex = href.indexOf('#');

// 			if (anchorIndex !== -1) {
// 				const targetUrlWithoutHash = href.slice(0, anchorIndex);
// 				const currentUrlWithoutHash = window.location.pathname + window.location.search;

// 				const isSamePageLink = (targetUrlWithoutHash === '' || targetUrlWithoutHash === currentUrlWithoutHash);

// 				if (isSamePageLink) {
// 					event.preventDefault();
// 					const targetId = href.slice(anchorIndex + 1);
// 					const targetElement = document.getElementById(targetId);
// 					if (targetElement) {
// 						const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
// 						window.scrollTo({
// 							top: targetPosition - headerHeight,
// 							behavior: 'smooth'
// 						});
// 					}
// 				}
// 			}
// 		}
// 	}

// 	document.addEventListener('click', handleAnchorClick);
// }

// /**
//  * アンカーリンク（ページ遷移）
//  */
// function handleCrossPagesAnchorLinks() {
// 	const header = document.querySelector('.l-header');
// 	const headerHeight = header ? header.offsetHeight : 0;

// 	if (window.location.hash) {
// 		const targetId = window.location.hash.slice(1);
// 		const targetElement = document.getElementById(targetId);
// 		if (targetElement) {
// 			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
// 			window.scrollTo({
// 				top: targetPosition - headerHeight,
// 				behavior: 'smooth'
// 			});
// 		}
// 	}
// }